module.exports = __webpack_public_path__ + "img/wizard_wechat-group.78c15000.png";